import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { OAUTH_GOOGLE_CLIENT_ID } from 'utils/request/config';
import { store } from './store';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // <React.StrictMode>
    <GoogleOAuthProvider clientId={OAUTH_GOOGLE_CLIENT_ID}>
        <BrowserRouter>
            <CookiesProvider>
                <Provider store={store}>
                    <App />
                </Provider>
            </CookiesProvider>
        </BrowserRouter>
    </GoogleOAuthProvider>,
    // </React.StrictMode>,
);

reportWebVitals();
